import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { LoaderCircle } from 'lucide-react';

import { queryKeys } from '@constants/queryKeys.constant';
import { EStaleTime } from '@enums/staleTime.enum';
import { TaskUpdateForm } from '@routes/_layout.(private)/tasks/@components/UpdateForm';
import { taskService } from '@services/tasks/service';

function taskQueryOptions(id: string) {
  return queryOptions({
    queryKey: queryKeys.tasks.detail(id),
    queryFn: () => taskService.getById(id),
    staleTime: EStaleTime.OneHour,
  });
}

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/tasks/$taskId/update',
)({
  component: ServiceRequestTaskUpdate,
  loader: ({ context, params }) => {
    const options = taskQueryOptions(params.taskId);
    return context.queryClient.ensureQueryData({
      ...options,
      revalidateIfStale: true,
    });
  },
  pendingComponent: () => (
    <div className="flex min-h-dvh w-full items-center justify-center">
      <LoaderCircle className="text-primary animate-spin" size={80} />
    </div>
  ),
  pendingMs: 300,
  pendingMinMs: 600,
});

function ServiceRequestTaskUpdate() {
  const { id: serviceRequestId, taskId } = Route.useParams();

  const { data } = useSuspenseQuery(taskQueryOptions(taskId));

  return (
    <TaskUpdateForm
      queryKeyToToggle={queryKeys.serviceRequests.detail(serviceRequestId)}
      serviceRequestId={serviceRequestId}
      task={data.task}
    />
  );
}
